export default class Observerable {
    subscriberList = []

    subscribe(subscriber) {
        if (!subscriber || typeof subscriber !== 'function') {
            throw Error('Subscriber should be function')
        }
        this.subscriberList.push(subscriber)
        // return pos for unsubscribe
        return this.subscriberList.length - 1
    }

    notify(data) {
        this.subscriberList.map((subscriber) => subscriber(data))
    }

    unsubscribe(pos) {
        this.subscriberList.splice(pos, 1)
    }
}
